import React, { useState } from 'react';
import uuid from 'react-uuid';
import moment from 'moment';
import TodoTaskList from '../../components/todo-task-list';

const TodoTask = () => {
	const [todoTask, setTodoTask] = useState('');
	const [todoTaskData, setTodoTaskData] = useState([]);

	const handleOnChangeTodoTask = (e) => {
		const task = e.target.value;
		setTodoTask(task);
	};

	const handleSubmitTask = () => {
		if (todoTask === '') {
			alert('Please enter valid input');
		} else {
			setTodoTaskData([
				...todoTaskData,
				{ id: uuid(), task: todoTask, timeStamp: moment().valueOf() },
			]);
			setTodoTask('');
		}
	};

	const handleDeleteItem = (item) => {
		const data = todoTaskData.filter((i) => i.id !== item.id);
		setTodoTaskData(data);
	};

	return (
		<div>
			TodoTask
			<div>
				<input value={todoTask} onChange={handleOnChangeTodoTask} />
				<button onClick={handleSubmitTask}>Click</button>
			</div>
			<div>
				<TodoTaskList
					todoTaskData={todoTaskData}
					handleDeleteItem={handleDeleteItem}
				/>
			</div>
		</div>
	);
};

export default TodoTask;
